import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f721376"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "cards"
}

import { ref } from "vue";
import { useStore } from "vuex";

import IndexTabs from "@/components/IndexTabs.vue";
import Cards from "@/components/Cards.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardScreen',
  setup(__props) {

const store = useStore();

const isActive = ref(false);
store.subscribe((mutation) => {
  if (mutation.type === "start") {
    isActive.value = true;
  }
  if (mutation.type === "finish") {
    isActive.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (isActive.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(Cards),
        _createVNode(IndexTabs)
      ]))
    : _createCommentVNode("", true)
}
}

})